import type { ImageType } from '@/core/features/image-v2/image-type';
import type { ResponseImageLayoutWidth } from '@/core/features/image-v2/responsive-image';

import { PlayIcon } from '@/assets/icons/play';
import { ResponsiveImage } from '@/core/features';
import color from '@/core/features/styles/color';

type GalleryImageProps = {
    height: number;
    image: ImageType;
    isVideo: boolean;
    layoutWidth: ResponseImageLayoutWidth;
    preload: boolean;
};
export default function GalleryImage(props: GalleryImageProps) {
    const { height, image, isVideo, layoutWidth } = props;

    return (
        <>
            <ResponsiveImage
                alt={image.imageAlt}
                height={height}
                layoutWidth={layoutWidth}
                preload={props.preload}
                url={image.imageUrl}
            />
            {isVideo && (
                <PlayIcon
                    className={'absolute-full'}
                    color={color('white')}
                    height={32}
                    width={32}
                />
            )}
        </>
    );
}
